// @avantia common-code
import { SMap } from '@avantia/client-and-server-utilities';
import { HpFetchErrorPayload } from './actionTypes';
import { HpLoadingPageTypes } from './ajaxCallActionTypes';
import { HpFeatureToggleState } from './featureToggle';
import { HpClientQuestionSetState } from './questionSetTypesClient';

export interface HpUserInterfaceState {
  ajaxCallsInProgress: number;
  ajaxCallsMap: SMap<HpLoadingPageTypes>;
  disableButtons: boolean;
  fetchError?: HpFetchError;
  viewport: HpViewportState;
}

export interface HpViewportState {
  height: number;
  isDesktop: boolean;
  isMobile: boolean;
  isTablet: boolean;
  size: HpViewportSizeTypes;
  width: number;
}

export type HpViewportSizeTypes = 'mobile' | 'tablet' | 'desktop';

export const allViewportSizeTypes: Readonly<HpViewportSizeTypes[]> = Object.freeze([
  'mobile',
  'tablet',
  'desktop'
] as HpViewportSizeTypes[]);

export interface HpFetchError {
  count?: number;
  description: string | undefined;
  error: string | Record<string, any>;
  errorCode?: string | undefined;
  errorDetails?: Record<string, any>;
  message: string | HpFetchErrorPayload;
  showErrorPage?: boolean;
  timestamp: number;
}

export interface HpGlobalEngineState<QuestionSetStateT extends HpClientQuestionSetState = HpClientQuestionSetState> {
  featureToggles: HpFeatureToggleState;
  questionSet: QuestionSetStateT;
  userInterface: HpUserInterfaceState;
}
